@if (isLoading) {
	<div class="overlay-new"></div>
}

<div class="service-header-wrapper">
	<h2 class="mat-heading">{{ 'mes.administration.users.employees' | translate }}</h2>
	<div class="service-header-buttons">
		<div class="acies-density-high acies-list-search-field">
			<mat-form-field>
				<input matInput (keyup)="applyFilter($event)" [placeholder]="'insights.administration.users.search' | translate" #input [cdkTrapFocusAutoCapture]="showSearch" [cdkTrapFocus]="showSearch" />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>
		<button mat-flat-button color="primary" style="margin-right: 1rem" (click)="toggleShowInactive()">
			{{ 'mes.administration.users.isActive.' + showInactive | translate }}
		</button>
		<header-sub-menu [favoriteItems]="favoriteItems" [menuItems]="menuItems"></header-sub-menu>
	</div>
</div>

<table class="table-responsive" mat-table recycleRows [dataSource]="dataSource" matSort (matSortChange)="onSort($event)">
	<ng-container matColumnDef="name">
		<th class="prevent-select" mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'mes.administration.users.alias' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">({{ element.alias }}) {{ element.name }}</td>
	</ng-container>

	<ng-container matColumnDef="department">
		<th class="prevent-select" mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'mes.administration.users.department' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">{{ element.department }}</td>
	</ng-container>

	<ng-container matColumnDef="team">
		<th class="prevent-select" mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'mes.administration.users.team-profile' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">{{ element.team }}</td>
	</ng-container>

	<ng-container matColumnDef="isActive">
		<th class="prevent-select" mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">
			{{ 'mes.administration.users.isActive.label' | translate }}
		</th>
		<td mat-cell *matCellDef="let element" style="text-align: center">
			<mat-icon svgIcon="{{ element.isActive ? 'acies_true' : 'acies_false' }}" [ngClass]="element.isActive ? 'greenColor' : 'redColor'"></mat-icon>
		</td>
	</ng-container>

	<ng-container matColumnDef="firstWorkDate">
		<th class="prevent-select" mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'mes.administration.users.first-work-date' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">
			{{ element.firstWorkDate | date: 'd. MMM yyyy' }}
		</td>
	</ng-container>

	<ng-container matColumnDef="menu">
		<th mat-header-cell *matHeaderCellDef style="text-align: end"></th>
		<td mat-cell *matCellDef="let row" style="text-align: end">
			<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Edit user settings">
				<mat-icon mat-list-icon svgIcon="acies_overflow_menu" style="padding-top: 5px"></mat-icon>
			</button>
			<mat-menu #menu="matMenu">
				@if (!row.isActive) {
					<button mat-menu-item (click)="onToggleActive(row.employee)">
						<span>{{ 'mes.administration.users.activatebtn' | translate }}</span>
					</button>
				}
				@if (row.isActive) {
					<button mat-menu-item (click)="onToggleActive(row.employee)">
						<span>{{ 'mes.administration.users.deactivatebtn' | translate }}</span>
					</button>
				}
				<button mat-menu-item (click)="onEdit(row.employee)">
					<span>{{ 'mes.administration.users.editbtn' | translate }}</span>
				</button>
				<button mat-menu-item (click)="onDelete(row.employee)">
					<span>{{ 'mes.administration.users.deletebtn' | translate }}</span>
				</button>
			</mat-menu>
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
	<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>

<mat-paginator [pageSizeOptions]="[10, 20, 50, 100, 200, 500, 1000, 2000, 5000]" [pageSize]="1000" showFirstLastButtons></mat-paginator>
